<div id="Modal1" class="modal modal-show">
    <div class="modal-overlay" (click)="doAction()">
        &nbsp;
    </div>
    <div class="modal-panel">
        <button class="modal-closeButton" type="button" (click)="doAction()">
            <svg width="24px" height="24px">
                <use xlink:href="assets/images/icons.svg#x-thick"></use>
            </svg>
            <span class="visually-hidden">Close Modal</span>
        </button>
        <div class="modal-container">
            <div class="modal-body" style="overflow: visible; align-content: center;">
                <div class="modal-content align-items-center" style="border: none; text-align: center">
                    <img src="assets/images/complete.svg" class="mb-5" alt="success">
                    <p class="colored fs-21 fw-bold mb-0">
                        {{ content.message| translate }}
                    </p>
                </div>
            </div>
            <div class="modal-actions p-0">
                <div class="row mx-auto w-100 justify-content-center">
                    <div class="col-8 d-flex flex-column gx-5">
                        <button (click)="doAction()" type="button" class="button button-primary">
                            <span>{{ content.button | translate }}</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
